document.addEventListener("DOMContentLoaded", function() {
  var eci_faq = {
    data: {},
    prepare_retinol: function () {
      try{
        this.data = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
          "@type": "Question",
          "name": "How do I apply Retinol ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Retinol should be applied after cleansing and toning and before moisturizer as part of the “treatment” step in your routine. It works really well at night - this is because UV rays from the sun have been shown to destabilize the ingredient through oxidation. Modern forms of retinol, however, are much more stable, and less prone to oxidation from UV rays. Encapsulation adds another protective layer of stabilization. With all that being said, retinol is also a great addition to your daytime skincare, but using a good sunscreen is a must."
          }
          }, {
          "@type": "Question",
          "name": "How often should I use Retinol ?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The first thing you should be mindful of is not using too much free form retinol all at once. Because this ingredient helps to reveal new skin, that means it has the potential to cause flaking and sensitivity in new users. An easy way to mitigate these side effects is to start slowly, by applying free retinol products once every other day or even only twice a week. As your skin adjusts, you can work your way up to using retinol several days in a row at a time."
          }
          }, {
          "@type": "Question",
          "name": "I heard Retinol is vulnerable to oxidation. How should I store it?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Modern forms of retinol are much more stable, and encapsulation adds extra protection. To be safe, our jars are tinted and coated to protect from UV rays, and we always recommend storing actives in a cool, dry location away from direct sunlight."
          }
          }, {
          "@type": "Question",
          "name": "Is it good for acne-prone skin?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Retinol is great for treating and preventing acne that’s caused by clogged pores. This is because it promotes skin cell regeneration that clears out acne on the surface level. It’s for that same reason that retinol is amazing for brightening dark spots and treating hyperpigmentation. It evens out your complexion over time to fade away any discoloration you may have."
          }
          }, {
          "@type": "Question",
          "name": "Is it okay to use on sensitive skin?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":"Modern forms of retinol are much more stable, and added encapsulation makes this ingredient much more suitable to sensitive skin. While encapsulated retinol releases slowly over time, traditional retinol releases all at once upon application. This initial surface interaction is what can cause irritation in uninitiated retinol users, so encapsulated retinol is the perfect option for newer users or for those with sensitive skin. Pairing retinol with soothing and hydrating ingredients also make it appropriate for use on sensitive skin."
          }
          }, {
          "@type": "Question",
          "name": "I heard Retinol can cause skin damage from the sun. Is that true?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":"Retinol in itself does not cause sun sensitivity. However, skin irritation can occur within initial uses which can be exacerbated by excessive sun exposure. We recommend wearing sunscreen every day, especially when using retinol."
          }
          }, {
          "@type": "Question",
          "name": "Why do I have to use an SPF after Retinol in the daytime?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":"Retinol destabilizes with UV, so it won’t work if you don’t protect it from the sunlight. UV also enhances the likelihood of irritation, which is why it is better to use at night if you are experiencing irritation."
          }
          }, {
          "@type": "Question",
          "name": "Is your Retinol vegan?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":"Yes, both of our Avocado Melt Retinol formulas are vegan."}
          }]
        }
        }catch(exp){
        }
    },
    render_retinol: function () {
      var obj = this;
      jQuery("#eci-faq").text(JSON.stringify(obj.data));
      },
    prepare_help_center: function(){
      data1: {};
      try{
        this.data1 = {

            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
            "@type": "Question",
            "name": "How do I qualify for free shipping?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "<p>We offer free shipping for all USA orders over $35! The order must total $35 after any discounts are applied and before taxes are added.</p>"
            }
            }, {
            "@type": "Question",
            "name": "When will my order ship and where does Glow Recipe ship from?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "<p>We process and ship out orders Monday through Friday, excluding holidays. Orders with standard shipping will usually be fulfilled and shipped the following business day (Monday through Friday, not including holidays).</p><p>Once shipped, you’ll receive an email from love@glowrecipe.com with tracking information within 24 hours. Please note, it can take up to 48 hours for your tracking information to update.</p><p>Glow Recipe ships from the Northeastern USA.</p>"
            }
            }, {
            "@type": "Question",
            "name": "What shipping methods does Glow Recipe offer?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "<p>Our standard shipping method is FedEx SmartPost, which usually arrives within 5-8 business days. We also offer FedEx Express (3-4 business days), and FedEx 2nd Day Air.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Does Glow Recipe charge domestic sales tax?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "<p>Domestic sales tax will be applied to all orders shipping to New York, New Jersey, and California.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Who are Glow Recipe's U.S. stockists?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe Skincare can be found at the following retailers: Sephora Sephora in JC Penny Sweet Chef can be found at the following retailers:Target</p>"
            }
            }, {
            "@type": "Question",
            "name": "Does Glow Recipe ship internationally?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Absolutely! Glow Recipe ships to the following countries:</p><p>Canada, New Zealand, The Philippines, Poland, Switzerland, Ireland, Israel, Belgium, Croatia, Denmark,Greece, Hungary, Iceland, Luxembourg, United Kingdom, Costa Rica, Finland, Slovenia, Norway, Portugal, Spain, France, Germany, Sweden, Indonesia, Vietnam, Australia, Malaysia, Hong Kong, and Singapore.</p><p>We hope to add more countries to this list as we continue to expand!</p>"
            }
            }, {
            "@type": "Question",
            "name": "What international shipping methods does Glow Recipe offer?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>All international orders are shipped with USPS International First Class mail. This service includes a USPS tracking number. Please note this tracking number may not provide updates once leaving the USA.</p><p>International shipping takes between 10-15 business days. We do not offer express international shipping at this time. Shipping to Canada is a flat rate of $17.50. Shipping to every other country is a flat rate of $28.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Is my package subject to customs fees and/or duty tax?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Your package may be subject to customs fees calculated by, and paid to your local government. Glow Recipe is not responsible for customs fees or duty taxes.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Can Glow Recipe ship my package as a ‘gift’, or mark the value of the items lower?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe is legally required to declare the actual value and contents of each package shipped internationally.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Who are Glow Recipe's international stockists?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe Skincare can be found at the following retailers:</p><ul><li>Cult Beauty</li><li>Douglas (Germany)</li><li>Mecca (Australia)</li></ul>"
            }
            }, {
            "@type": "Question",
            "name": "Can I cancel or change my order?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe cannot alter an order once it has been placed. This includes adding or removing any items in the order, or changing the shipping method.</p><p>If you need to update your address or cancel an order, email love@glowrecipe.com. Our customer service team will do their best to stop the order, however, this is not guaranteed.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Can I return my purchase?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Your 100% satisfaction is important to us. US return shipping is free of charge and on us. Glow Recipe allows 30 day returns for all product except for those listed below.* Please email love@glowrecipe.com and we will email you a label for free return shipping. Please note that the original shipping costs cannot be refunded. We do not accept returns or exchanges on international orders and shipments, including packages that are shipped to Canada. *Please note that single-use products are eligible for return only if it is unused and in its original packaging. This includes sheet masks, rubber masks, and bubble mesh masks. Any Starter Kits, Box Sets, Routine Kits or Mystery Boxes are final sale and ineligible for return.</p>"
            }
            }, {
            "@type": "Question",
            "name": "My order arrived with something missing/incorrect/damaged.",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>If your Glow Recipe package arrives missing an item, with incorrect items, or with any damage to the items, email us right away at love@glowrecipe.com. Please include photos of your packing slip and any damage.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Is the product I received expired?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Each product has it's own PAO, or period-after-opening date in which the product should be used. The time is indicated in months and can be found inside or alongside a symbol of a open cream jar printed on the packaging. Please reference your specific product's PAO to ensure you get the most use out of your products.</p>"
            }
            }, {
            "@type": "Question",
            "name": "What is the Glow Rewards program?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Rewards is our rewards program with one goal: making it faster and easier for you to achieve beautifully glowing skin! It’s also our way of thanking you for joining us on this K-beauty journey.  Earn rewards for every purchase made, for sharing us on social media, for referring friends to Glow Recipe, and even for your birthday!</p><p>The Glow Rewards program is open to all customers worldwide! Sign up here.</p>"
            }
            }, {
            "@type": "Question",
            "name": "How do I earn Glow Rewards?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>You can earn rewards from the following activities: Sign Up: New customers who sign up for the program will get started with 100 Rewards! These rewards will be automatically added upon account set up. Purchases: All qualifying purchases earn rewards for every dollar spent, depending on your membership tier (Glow-Getter, Glow-Jetter, or Glow First [link here to GM page explaining tiers]) Birthday Rewards: Celebrate your birthday with an additional 50 Rewards! These rewards will be automatically added within 24 hours of your birthday each year. Refer-a-Friend: Your friend will receive 15% off their first purchase and you will be rewarded with 200 rewards. You can refer as many friends as you like! You can find your referral link by logging into your account, clicking the blue Glow Rewards icon on the bottom left of the page, and scrolling to the bottom of the pop-up window. Reviews: Leave a product review on glowrecipe.com for 100 rewards*. Your Glow Rewards will update within 48 hours. If your Glow Rewards have not been added after 48 hours, email us with a screenshot of the review to have the rewards added manually. Love@glowrecipe.com. Social Sharing: Follow us on Twitter or Instagram, or share us on Facebook or Twitter for 15 rewards. Like us on Facebook for 15 rewards. These tasks must be completed from our website, while logged into your Glow Rewards account. *Applies to one (1) review per customer per day. Reviews are only eligible if accessed via the Yotpo review email sent to you after each product purchase. Reviews left directly on our site and on products that have not been purchased on GlowRecipe.com are not eligible. </p>"
            }
            }, {
            "@type": "Question",
            "name": "Can I change my Glow Rewards account details or merge two accounts?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Yes! We can change account details like your name, email address, and shipping address. Email us at love@glowrecipe.com with the details of your request.Unfortunately, two different accounts can't be merged.</p>"
            }
            }, {
            "@type": "Question",
            "name": "My Glow Rewards are not updating/not accurate!",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>If your total does not reflect reviews you’ve left, or social media tasks you’ve completed, email our customer service team at love@glowrecipe.com. We’ll look into the issue and reward you any rewards you may be missing.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Does Glow Recipe offer any promotional or discount codes?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe offers all first-time buyers 10% off their first order when you sign up for our mailing list located at the bottom of our website. You’ll be emailed a confirmation link from love@glowrecipe.com to click, resulting in a 10% off code emailed to you within 48 hours. Make sure to check your spam/junk folders! Sign up to our mailing list located at the bottom of our website, to receive exclusive promotions and discounts!</p>"
            }
            }, {
            "@type": "Question",
            "name": "Does Glow Recipe offer gift cards, gift receipts or gift wrapping?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe is happy to offer e-gift cards.that you can purchase and email to the recipient of your choice. Gift cards are sent electronically and are not physical items. Discount codes cannot be used towards the purchase of an e-gift card.</p><p>Glow Recipe does not offer gift wrapping at this time. However, every domestic order is shipped with a gift receipt, which does not reveal any pricing or payment information.</p>"
            }
            }, {
            "@type": "Question",
            "name": "What payment methods does Glow Recipe accept?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe accepts all major credit cards, including Visa, American Express, Mastercard and Discover. We also accept PayPal and Amazon Pay.</p>"
            }
            }, {
            "@type": "Question",
            "name": "How do I apply promotional codes or e-gift cards to my order?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>First, copy the promotional or gift card code you intend to use. When at the checkout stage in your shopping cart, paste the code into the grey box marked ‘Gift Card or Discount Code’, and click ‘apply’. One discount code may be used per order.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Is the product I received expired?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>You can find products by keyword or ingredient using the search icon at the top right corner of each page.</p><p>You can also browse by skincare concern and product type, using the links in the header at the top of each page.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Where can I find ingredients lists and instructions to use each product?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Under each product description are multiple tabs to explain key ingredients, usage, FAQ, and more. Click each tab to learn more!</p>"
            }
            }, {
            "@type": "Question",
            "name": "Product availability and out of stock items.",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<pAll products able to be added to your shopping cart are in-stock and ready to ship unless it is a ‘PRE-ORDER’ item. Any ‘PRE-ORDER’ items will be noted as such in the description. You can sign up to be notified when an out of stock item is replenished by clicking ‘Email When Available’ in the description.</p>"
            }
            }, {
            "@type": "Question",
            "name": "So many products! So much information! Where does a newbie begin?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Our goal is to make this journey as easy and intuitive as possible. Everyone’s skin is unique, so finding the best products for your skin type will always be a trial and error process. We’re here to make the process fun and offer advice on every single aspect! The best place to begin is our blog. Use the search function to find informative & fun articles on almost any skincare topic, before and after testimonials, and advice from skin care experts & dermatologists. Need to find the best sunscreen for dry, oily, or combo skin? There’s an article for that! Wondering what order to apply acids? We got you!. Need to alter your routine for winter or summer? Check here and check here!</p>"
            }
            }, {
            "@type": "Question",
            "name": "What is the 10-step method and do I need all 10 steps?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"You’ve probably heard about the 10, 15, even 20 step Korean skincare routine. And we’re here to tell you that nothing could be further from the truth. Korean women do own a lot of products and also do use a lot from them, but the true Korean skin care routine is fluid and customized to how one’s skin feels at the time. No specific number of products is set in stone. Some days, one could layer on a essence and a serum before the moisturizer, but on other days, it could just be a sleeping cream and nothing else. Finding the right routine will be a unique, personal process and we’re here to help! Email us for personalized recommendations at love@glowrecipe.com"
            }
            }, {
            "@type": "Question",
            "name": "Does Glow Recipe offer complete skincare routines in one package?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Absolutely! Glow Recipe offers thoughtfully curated complete skincare routines for almost every skin concern, including mature skin, acne-prone skin, sensitive skin, and we also offer sheet mask sets. Find our complete selection of K-beauty routine kits here.</p>"
            }
            }, {
            "@type": "Question",
            "name": "How should I apply my products?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>In general, products sound be applied in order from thinnest to densest, so that the lightweight products are applied first. There are exceptions to this, like acids.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Does Glow Recipe offer skin consultations via email?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>We are happy to offer you a mini-consultation, complete with recommendations and detailed instructions! Email us at for a response within 1 business day. Please keep in mind that it can be hard to treat skin conditions with skin care alone, so if experiencing any on-going irritation, we recommend consulting with a dermatologist.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Does Glow Recipe have any products for pregnant or nursing moms?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>We recommend checking the ingredients list of any product you intend to use while pregnant or nursing, with your doctor to allay concerns.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Is Glow Recipe cruelty-free?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>Glow Recipe Skincare is 100% cruelty-free and we do not test our formulas on animals.</p>"
            }
            }, {
            "@type": "Question",
            "name": "Is Glow Recipe Skincare vegan?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":"<p>With the exception of our Avocado Melt Sleeping Mask (which contains manuka honey), Glow Recipe is vegan-friendly and does not use animal-derived ingredients.</p>"
            }
            }]
          }
        }catch(exp){
        }
    },
    render_help_center: function () {
      var obj = this;
      jQuery("#eci-faq").text(JSON.stringify(obj.data1));
    },
    prepare_watermelon: function(){
      data2: {};
      try{
        return this.data2 = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [{
          "@type": "Question",
          "name": "WHY WATERMELON?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The naturally sweet fruit is made of 92% water and is jam-packed with protective vitamins A and C, skin-plumping amino acids, and the phytonutrient lycopene. It basically does it all: moisturizes, plumps, and soothes, as well as helps to treat pores, flakiness, fine lines, and wrinkles."
          }
          }, {
          "@type": "Question",
          "name": "WHAT ELSE MAKES THIS MAGICAL?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "HYALURONIC ACID This holy grail hydrator instantly quenches thirsty skin and retains 1000 times its weight in water to breathe new life to dry, rough skin. AHA Gentle chemical exfoliators that buff away dead skin, smooth fine lines, soften texture, diminish dark spots, and clarify pores. In other words, they help your skin live its best life. PUMPKIN EXTRACT This ingredient is rich in antioxidants that both repair skin and defend it against damage-causing free radicals. SEAWEED Soothes inflammation and promotes skin repair using its powerful polysaccharide, fucoidan. BANANA Rich in vitamins and minerals, especially potassium and vitamin E, helping to nourish and soften skin by restoring skin’s constant water depletion. POMEGRANATE Contains powerful antioxidants like tannins and polyphenols, and vitamins A, C, and E to help reduce the look of pores and rejuvenate skin."
          }
          }, {
          "@type": "Question",
          "name": "HOW IT'S MADE",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Every part of the process of making the Watermelon Mask is done by hand:<br>We hand-cut fresh watermelon, and use every part of the fruit (including the rind, which later gets added into the mixture) to ensure there’s zero waste."
          }
          }, {
          "@type": "Question",
          "name": "HOW TO USE AS A SLEEPING MASK:",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Apply a generous layer on skin as the final step of your evening routine. When your skin is feeling dry, layer an additional dime-sized amount onto the skin. Be sure to gently pat-not rub-the mask into skin until absorbed and wash thoroughly in the morning."
          }
          }, {
          "@type": "Question",
          "name": "HOW TO USE AS A FLASH FACIAL:",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":"Apply a thick layer to clean, dry skin. After 10 minutes, wash thoroughly and follow with your skincare routine. PS—We love using this before makeup for a flawless application."
          }
          }, {
          "@type": "Question",
          "name": "HOW TO USE IT OTHER WAYS:",
          "acceptedAnswer": {
            "@type": "Answer",
            "text":"Target T-Zone to help reduce the appearance of pores. Spot treat flaky areas (dry spots, elbows, knees—literally wherever) for baby soft skin all over. Apply to neck to smooth and plump. Use to give a facial lymphatic drainage massage."
          }
          }]
        }
      }catch(exp){
      }
    },
    render_watermelon: function () {
      var obj = this;
      jQuery("#eci-faq").text(JSON.stringify(obj.data2));
    },
    init: function () {
      if (window.location.href.indexOf('pages/retinol') > 0) {
        this.prepare_retinol();
        this.render_retinol();
      }
      if (window.location.href.indexOf('pages/watermelon') > 0) {
        this.prepare_watermelon();
        this.render_watermelon();
      }
    }
  };

  eci_faq.init();
});